const rup = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function InvoiceA4({ order, biz }) {
  const items = order.items || [];
  const gstGrouped = {};
  items.forEach((i) => { const r = i.tax_rate || 0; const g = gstGrouped[r] || { taxable: 0, gst: 0 }; g.taxable += i.taxable || 0; g.gst += i.line_gst || 0; gstGrouped[r] = g; });

  return (
    <div className="sheet a4" data-testid="invoice-a4">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          {biz.logo && <img src={biz.logo} alt="" style={{ width: 54, height: 54, objectFit: "contain" }} />}
          <div>
            <div style={{ fontWeight: 800, fontSize: 20 }}>{biz.name}</div>
            {biz.address && <div style={{ fontSize: 12, color: "#475569" }}>{biz.address}{biz.city ? `, ${biz.city}` : ""}{biz.state ? `, ${biz.state}` : ""}</div>}
            {biz.phone && <div style={{ fontSize: 12, color: "#475569" }}>Ph: {biz.phone}{biz.email ? ` · ${biz.email}` : ""}</div>}
            {biz.show_gst && biz.gstin && <div style={{ fontSize: 12, color: "#475569" }}>GSTIN: {biz.gstin}</div>}
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontWeight: 800, fontSize: 16 }}>TAX INVOICE</div>
          <div style={{ fontSize: 12 }}>No: <b>{order.invoice_no || order.order_no}</b></div>
          <div style={{ fontSize: 12 }}>{new Date(order.created_at).toLocaleString("en-IN")}</div>
        </div>
      </div>
      <div style={{ fontSize: 12, marginBottom: 8, color: "#334155" }}>
        <b>Bill To:</b> {order.customer_name || "Walk-in"} {order.customer_phone ? `· ${order.customer_phone}` : ""}
      </div>
      <table>
        <thead><tr><th>#</th><th>Item</th><th>HSN</th><th style={{ textAlign: "right" }}>Rate</th><th style={{ textAlign: "right" }}>Qty</th><th style={{ textAlign: "right" }}>Disc</th><th style={{ textAlign: "right" }}>Taxable</th><th style={{ textAlign: "right" }}>GST%</th><th style={{ textAlign: "right" }}>Amount</th></tr></thead>
        <tbody>
          {items.map((i, x) => (
            <tr key={`${i.product_id || i.name}-${x}`}><td>{x + 1}</td><td>{i.name}</td><td>{i.hsn || "-"}</td><td style={{ textAlign: "right" }}>{rup(i.price)}</td><td style={{ textAlign: "right" }}>{i.quantity}</td><td style={{ textAlign: "right" }}>{rup(i.discount)}</td><td style={{ textAlign: "right" }}>{rup(i.taxable)}</td><td style={{ textAlign: "right" }}>{i.tax_rate}%</td><td style={{ textAlign: "right" }}>{rup(i.line_total)}</td></tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12, gap: 20 }}>
        <table style={{ width: 300, fontSize: 11 }} className="a4">
          <thead><tr><th>GST%</th><th style={{ textAlign: "right" }}>Taxable</th><th style={{ textAlign: "right" }}>CGST</th><th style={{ textAlign: "right" }}>SGST</th></tr></thead>
          <tbody>{Object.entries(gstGrouped).map(([r, g]) => <tr key={r}><td>{r}%</td><td style={{ textAlign: "right" }}>{rup(g.taxable)}</td><td style={{ textAlign: "right" }}>{rup(g.gst / 2)}</td><td style={{ textAlign: "right" }}>{rup(g.gst / 2)}</td></tr>)}</tbody>
        </table>
        <table style={{ width: 280, fontSize: 13 }}>
          <tbody>
            <tr><td style={{ padding: "3px 0" }}>Subtotal</td><td style={{ textAlign: "right" }}>{rup(order.subtotal)}</td></tr>
            {order.discount > 0 && <tr><td>Discount</td><td style={{ textAlign: "right" }}>-{rup(order.discount)}</td></tr>}
            <tr><td>Total GST</td><td style={{ textAlign: "right" }}>{rup(order.gst)}</td></tr>
            {order.extra_charge > 0 && <tr><td>Charges</td><td style={{ textAlign: "right" }}>{rup(order.extra_charge)}</td></tr>}
            {order.round_off !== 0 && <tr><td>Round off</td><td style={{ textAlign: "right" }}>{rup(order.round_off)}</td></tr>}
            <tr style={{ fontWeight: 800, fontSize: 16, borderTop: "2px solid #111" }}><td style={{ paddingTop: 6 }}>Grand Total</td><td style={{ textAlign: "right", paddingTop: 6 }}>{rup(order.total)}</td></tr>
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: 10, fontSize: 12, color: "#334155" }}>
        {(order.payments || []).map((p, x) => <span key={`${p.method}-${x}`} style={{ marginRight: 12, textTransform: "capitalize" }}>{p.method}: {rup(p.amount)}</span>)}
        {order.credit_amount > 0 && <span style={{ fontWeight: 700, color: "#b45309" }}>Udhaar due: {rup(order.credit_amount)}</span>}
      </div>
      {biz.terms && <p style={{ fontSize: 11, color: "#64748b", marginTop: 16, whiteSpace: "pre-wrap" }}>{biz.terms}</p>}
      <p style={{ textAlign: "center", fontSize: 12, marginTop: 20, color: "#475569" }}>{biz.footer_note}</p>
    </div>
  );
}
